/**
 * Возвращает объект сохраненных сессий чатов
 * @returns {any}
 */
const getSavedSessions = () => JSON.parse(localStorage.getItem('mk_jivo_sessions') || '{}');

/**
 * Загружает в виджет сессию чата по юзеру
 * @param userId
 */
const loadSessionByUserId = (userId) => {
  // Получим все сохраненные сессии
  const savedSessions = getSavedSessions();
  const savedSession = savedSessions[userId];

  if (!savedSession) {
    return;
  }

  Object.keys(savedSession).forEach((key) => {
    let value;

    try {
      value = JSON.stringify(savedSession[key]);
    } catch (e) {
      value = savedSession[key];
    }

    localStorage.setItem(key, value);
  });
};

/**
 * Сохраняет сессию чата
 * @param widgetId
 * @param userId
 */
const saveSession = (widgetId, userId) => {
  // Получим текущую сессию чата
  const currentSessionObj = {};
  Object.keys(localStorage).forEach((key) => {
    if (/^jv_/i.test(key)) {
      const value = localStorage.getItem(key);
      try {
        currentSessionObj[key] = JSON.parse(value);
      } catch (e) {
        currentSessionObj[key] = value;
      }
    }
  });

  const storeKey = `jv_store_${widgetId}_client`;
  const currentSessionStore = currentSessionObj[storeKey];
  if (!currentSessionStore || !currentSessionStore.jv_sess_id) {
    return;
  }

  // Получим все сохраненные сессии
  const savedSessions = getSavedSessions();

  // Сохраним сессию по ID юзера
  savedSessions[userId] = currentSessionObj;
  localStorage.setItem('mk_jivo_sessions', JSON.stringify(savedSessions));
};

/**
 * Удаляет виджет и очищает все, что он хранил в localStorage
 */
const destroyCurrentChat = () => {
  const existingWidget = document.getElementById('jivoSiteWidget');
  if (existingWidget) {
    existingWidget.remove();
  }

  Object.keys(localStorage).forEach((key) => {
    if (/^jv_/i.test(key)) {
      localStorage.removeItem(key);
    }
  });

  window.jivo_destroy();
};

/**
 * Добавляет в виджет данные о юзере
 * @param userData
 */
const initWidgetData = (userData) => {
  const {
    name,
    phone,
    email,
    id: userId,
    jivoSiteUserToken,
  } = userData;
  const { jivo_api: jivoApi } = window;

  const widgetData = [{
    title: `Ученик №${userId}`,
    content: name,
    link: `https://app.moyklass.com/user/${userId}/joins`,
  },
  {
    title: 'Email в CRM',
    content: email,
  }];

  if (phone) {
    widgetData.push({
      title: 'Номер телефона в CRM',
      content: phone,
    });
  }

  const contactInfo = {
    email,
    phone,
    client_name: name,
    description: `ID ученика: ${userId}`,
  };

  jivoApi.setCustomData(widgetData);
  jivoApi.setContactInfo(contactInfo);
  jivoApi.setUserToken(jivoSiteUserToken);
};

export const initJivoSiteWidget = ({ widgetUrl, currentUser, previousUserId }) => {
  const widgetId = widgetUrl.split('/').pop();

  // Если виджет уже был создан, сохраним сессию предыдущего юзера и удалим виджет
  if (window.jivo_api) {
    saveSession(widgetId, previousUserId);
    destroyCurrentChat();
  }

  // Загрузим сессию чата юзера
  loadSessionByUserId(currentUser.id);

  // Когда виджет будет загружен, добавим инофрмацию о пользователе
  window.jivo_onLoadCallback = () => {
    initWidgetData(currentUser);
  };

  // Добавим виджет на страницу
  const jivoSiteWidget = document.createElement('script');
  jivoSiteWidget.src = widgetUrl;
  jivoSiteWidget.id = 'jivoSiteWidget';
  document.head.appendChild(jivoSiteWidget);
};

export const destroyJivoSiteWidget = ({ widgetUrl, currentUser }) => {
  const widgetId = widgetUrl.split('/').pop();

  // Если виджет уже был создан, сохраним сессию предыдущего юзера и удалим виджет
  if (window.jivo_api) {
    saveSession(widgetId, currentUser.id);
    destroyCurrentChat();
  }
};

export const noop = () => {};
